import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  onScrolledEvent: BehaviorSubject<any> = new BehaviorSubject<WheelEvent>(null);

}
